import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
// import CloseIcon from "@mui/icons-material/Close";

const CreateWorkflowPopup = ({
  open,
  onClose,
  onContinue,
  setWorkflowName,
  setWorkflowDescription,
  workflowName,
  workflowDescription,
}) => {
  //   const [name, setName] = useState("");
  //   const [description, setDescription] = useState("");
  const navigate = useNavigate();

  const handleContinue = () => {
    onContinue({ workflowName, workflowDescription });
    // onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ m: 0, p: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          Create Workflow
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => navigate('/')}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
            padding: '10px',
            border: '1px solid #ddd',
          }}
        >
          {/* Close Button */}
          <Box
            component="img"
            src="/images/workflow/Close.svg"
            alt="Close Icon"
            sx={{ width: 10, height: 10, margin: 'auto' }}
          />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box display="flex" flexDirection="row" gap={4}>
          <label
            style={{
              width: 200,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'normal',
            }}
          >
            Workflow Name
          </label>
          {/* <TextField
            // label="Workflow Name"
            
            fullWidth
            value={workflowName}
            onChange={(e) => setWorkflowName(e.target.value)}
            sx={{
                fontSize: '14px',
                padding:'8px'
              }}
          /> */}

          <TextField
            placeholder="Workflow Name"
            fullWidth
            value={workflowName}
            onChange={(e) => setWorkflowName(e.target.value)}
            inputProps={{ maxLength: 50 }}
            InputProps={{
              sx: {
                fontSize: '14px',
                paddingY: '0px', // vertical padding
                paddingX: '0px', // horizontal padding
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '2px',
              },
              '& .MuiOutlinedInput-input': {
                fontSize: '14px',
                padding: '10px 12px',
              },
            }}
          />
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ ml: '10px' }}
          >
            {workflowName.length}/50
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          gap={4}
          style={{ marginTop: 20 }}
        >
          <label
            style={{
              width: 200,
              display: 'flex',
              alignItems: 'center',
              fontWeight: 'normal',
            }}
          >
            Description
          </label>
          <TextField
            // label="Description"
            // style={{fontSize:'14px', padding:'10px'}}
            fullWidth
            value={workflowDescription}
            onChange={(e) => setWorkflowDescription(e.target.value)}
            inputProps={{ maxLength: 100 }}
            InputProps={{
              sx: {
                fontSize: '14px',
                paddingY: '0px', // vertical padding
                paddingX: '0px', // horizontal padding
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '2px',
              },
              '& .MuiOutlinedInput-input': {
                fontSize: '14px',
                padding: '10px 12px',
              },
            }}
          />
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ ml: '10px' }}
          >
            {workflowDescription.length}/100
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ m: 0, p: 3 }} style={{ fontSize: '14px' }}>
        <Button
          onClick={() => navigate('/')}
          color="inherit"
          style={{
            fontWeight: 'normal',
            textTransform: 'none',
            fontSize: '14px',
            marginRight: 10,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleContinue}
          style={{
            padding: '10px 20px',
            textTransform: 'none',
            fontSize: '14px',
            backgroundColor: 'var(--primary-color)',
          }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateWorkflowPopup;
